module.exports = __webpack_public_path__ + "img/sampson-street.ae366038.jpg";